import React from "react";
import { TrendingUp, ArrowUpRight } from "lucide-react";

const TOOLS = [
  { key: "keywords", name: "Keywords", icon: TrendingUp, tag: "SEO", description: "Daily Google rankings for each client's tracked keywords, with competitors, desktop and mobile." },
];

export default function ConsoleTools({ onOpen }) {
  return (
    <main className="px-6 md:px-10 py-10 max-w-6xl mx-auto" data-testid="console-tools-page">
      <div className="mb-8">
        <p className="font-mono-data text-[10px] uppercase tracking-[0.2em] text-[#723FFF]">Internal</p>
        <h1 className="font-display text-3xl md:text-4xl font-semibold tracking-tight text-[#06060C] mt-1">Tools</h1>
        <p className="mt-2 text-sm text-[#9FA1A4]">Utilities the team uses to run client work.</p>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {TOOLS.map((t, i) => (
          <button key={t.key} data-testid={`tool-card-${t.key}`} onClick={() => onOpen(t.key)} style={{ animationDelay: `${i * 40}ms` }}
            className="group text-left rounded-3xl border border-[#EEEFEF] bg-white p-6 hover:border-[#d9ccff] hover:shadow-[0_8px_30px_-12px_rgba(114,63,255,0.25)] transition-[border-color,box-shadow,transform] duration-200 hover:-translate-y-0.5 animate-in fade-in slide-in-from-bottom-1">
            <div className="flex items-start justify-between">
              <div className="h-11 w-11 rounded-2xl bg-[#EDE7FF] text-[#723FFF] flex items-center justify-center"><t.icon className="h-5 w-5" /></div>
              <ArrowUpRight className="h-4 w-4 text-[#c4c5cc] group-hover:text-[#723FFF] transition-colors" />
            </div>
            <div className="flex items-center gap-2 mt-5">
              <h3 className="font-display text-lg font-semibold text-[#06060C]">{t.name}</h3>
              <span className="font-mono-data text-[10px] uppercase tracking-wider rounded-full bg-[#F6F6FD] border border-[#EEEFEF] px-2 py-0.5 text-[#595D62]">{t.tag}</span>
            </div>
            <p className="text-sm text-[#595D62] mt-1.5 leading-relaxed">{t.description}</p>
          </button>
        ))}
      </div>
    </main>
  );
}
